import PropTypes from "prop-types";

const propTypes = {
  dodavatel: PropTypes.shape({
    I_DODAVATEL: PropTypes.number,
    I_O_TYP: PropTypes.number,
    NAZOV: PropTypes.string,
    ADRESA_SIDLO: PropTypes.string,
    ICO: PropTypes.string,
    DIC: PropTypes.string,
    ICO_DIC: PropTypes.string,
    TELEFON: PropTypes.string,
    MAIL: PropTypes.string,
    MAIL_FAKT: PropTypes.string,
    WEB: PropTypes.string,
    OBCH_REG: PropTypes.string,
  }),
};

export default propTypes;
